import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetPlanQuoteQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  purchasePlanId: Types.Scalars['ID']['input'];
  address?: Types.InputMaybe<Types.PlanQuoteAddressInput>;
  addOns?: Types.InputMaybe<Array<Types.PlanQuoteAddOnInput>>;
}>;


export type GetPlanQuoteQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, subscription: { __typename?: 'AccountSubscription', id: string, planQuote?: { __typename?: 'PlanQuote', dueNow?: number | null, subtotal?: number | null, tax?: number | null, taxExempt?: string | null, total?: number | null, taxLineItems?: Array<{ __typename?: 'TaxLineItem', amount?: number | null, rate?: number | null, displayName?: string | null } | null> | null, invoiceLineItems?: Array<{ __typename?: 'InvoiceLineItem', quantity?: number | null, unitAmount?: number | null, amount?: number | null, item?: { __typename?: 'LineItem', increment: number, modifier: string } | { __typename?: 'Plan', id: string, name?: string | null, userLimit?: number | null } | null } | null> | null } | null } } | null };


export const GetPlanQuote = /*#__PURE__*/ gql`
    query GetPlanQuote($accountId: ID!, $purchasePlanId: ID!, $address: PlanQuoteAddressInput, $addOns: [PlanQuoteAddOnInput!]) {
  account(accountId: $accountId) {
    id
    subscription {
      id
      planQuote(purchasePlanId: $purchasePlanId, address: $address, addOns: $addOns) {
        dueNow
        subtotal
        tax
        taxExempt
        total
        taxLineItems {
          amount
          rate
          displayName
        }
        invoiceLineItems {
          quantity
          unitAmount
          amount
          item {
            ... on Plan {
              id
              name
              userLimit
            }
            ... on LineItem {
              increment
              modifier
            }
          }
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<GetPlanQuoteQuery, GetPlanQuoteQueryVariables>;

          

          export const useGetPlanQuoteQuery = (options?:QueryHookOptions<GetPlanQuoteQuery, GetPlanQuoteQueryVariables>) => useQuery(GetPlanQuote, options);

          

          export type GetPlanQuoteQueryOptions = QueryHookOptions<GetPlanQuoteQuery, GetPlanQuoteQueryVariables>;

          

          export const useGetPlanQuoteLazyQuery = (options?:LazyQueryHookOptions<GetPlanQuoteQuery, GetPlanQuoteQueryVariables>) => useLazyQuery(GetPlanQuote, options);

          

          export type GetPlanQuoteQueryResult = ReturnType<typeof useGetPlanQuoteQuery>;

          
